import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import IconButton from '../../../../shared/components/IconButton/IconButton';
import TicketReportDialog from './TicketReportDialog';
import {getReportPage} from './ticketReportContext';
import './ticketReport.scss';

export default function TicketReportButton(){
 const {pathname}=useLocation();
 const [page,setPage]=useState(null);
 return <>
  <IconButton color="inherit" title="Signaler un problème" aria-label="Signaler un problème" onClick={()=>setPage(getReportPage(pathname))}><FeedbackOutlinedIcon/></IconButton>
  {page!==null&&<TicketReportDialog pageUrl={page} onClose={()=>setPage(null)}/>}
 </>;
}
